import { Badge, BadgeProps } from "@chakra-ui/react";

export type IsCustomBadgeProps = BadgeProps & {
  isCustom: boolean | null | undefined;
};

export default function IsCustomBadge({
  isCustom,
  ...rest
}: IsCustomBadgeProps) {
  if (isCustom === undefined || isCustom === null) return null;
  return (
    <Badge
      colorScheme={isCustom ? "blue" : undefined}
      variant={isCustom ? undefined : "outline"}
      opacity={isCustom ? undefined : 0.5}
      {...rest}
    >
      {isCustom ? "Custom" : "Default"}
    </Badge>
  );
}
